import { render, staticRenderFns } from "./CampaignChannels.vue?vue&type=template&id=33eb83a9"
import script from "./CampaignChannels.vue?vue&type=script&lang=js"
export * from "./CampaignChannels.vue?vue&type=script&lang=js"
import style0 from "./CampaignChannels.vue?vue&type=style&index=0&id=33eb83a9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports